module.exports = __webpack_public_path__ + "static/media/模块配置.adad0134.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/模块配置.png
// module id = 4721
// module chunks = 0